import { Directive, ElementRef, Inject, Input, OnInit } from '@angular/core';
import { THEME_TOKEN, Theme } from '../../../types/theme.types';
import { componentStylesByTheme } from '../../../utils/theme.utils';
import { style } from '../../../utils/style.utils';
import {
  stepperKnobTextStylesSAG,
  stepperKnobTextStylesSHS,
} from './stepper-knob-text.styles';

@Directive({
  selector: '[sag-ui-stepper-knob-text]',
})
export class StepperKnobTextDirective implements OnInit {
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      stepperKnobTextStylesSAG,
      stepperKnobTextStylesSHS
    );

    style(this.elementRef, inputStyles({ orientation: this.orientation }));
  }
}
